import { css } from 'styled-components';
import { mixin } from '../helpers/mixins';
import { borderRadius } from '../style/border-radius';
export const borderShadowMixin = css`
  transition: box-shadow 0.2s ease-out;
  ${({
  borderColor,
  $borderColor
}) => (borderColor || $borderColor) && `box-shadow: 0 0 0 1px ${borderColor || $borderColor};`}
`;
export const borderShadowKeys = ['borderColor'];
export const borderRadiusMixin = mixin(borderRadius, ['borderRadius', 'br']);
export const borderRadiusKeys = ['borderRadius', 'br'];